module.exports = __webpack_public_path__ + "static/img/324.3cb1b06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/324.jpg
// module id = jM46
// module chunks = 0